import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { ApikeysComponent } from './apikeys/apikeys/apikeys.component';
import { CrearEditarApikeyComponent } from './apikeys/crear-editar-apikey/crear-editar-apikey.component';
import { CrearEditarClienteComponent } from './clientes/crear-editar-cliente/crear-editar-cliente.component';
import { ListadoTrackersComponent } from './trackers/trackers/trackers.component';
import { CrearEditarTrackerComponent } from './trackers/crear-editar-tracker/crear-editar-tracker.component';
import { ListadoUsuariosComponent } from './usuarios/listado-usuarios/listado-usuarios.component';
import { MapDrawMapboxComponent } from '../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { UploadFileComponent } from '../../../auxiliares/upload-file/upload-file.component';
import { AdministracionRoutingModule } from './routing';
import { DetallesTrackerInfoComponent } from './trackers/detalles-tracker-info/detalles-tracker-info.component';
import { MatMenu } from '@angular/material/menu';
import { DetallesTrackersComponent } from './trackers/detalles-tracker/detalles-trackers.component';
import { ServiciosComponent } from './servicios-contratados/servicios/servicios.component';
import { CrearEditarServiciosComponent } from './servicios-contratados/crear-editar-servicios/crear-editar-servicios.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ClienteNotasComponent } from './clientes/clientes/cliente-notas/cliente-notas.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { DetallesClienteComponent } from './clientes/clientes/detalles-cliente/detalles-cliente.component';
import { DetallesClienteInfoComponent } from './clientes/clientes/detalles-cliente-info/detalles-cliente-info.component';
import { ListadoClientesGraficoComponent } from './clientes/clientes/clientes-listado-visual/clientes.component';
import { ListadoClientesTablaComponent } from './clientes/clientes/clientes-listado-tabla/clientes.component';
import { ListadoClientesComponent } from './clientes/clientes/clientes-listado/clientes-listado.component';
import { CambiarPadreDialogComponent } from './clientes/clientes/cambiar-padre-dialog/cambiar-padre-dialog.component';
import { TecnicosComponent } from './tecnicos/tecnicos/tecnicos.component';
import { CrearEditarUsuarioFuncionComponent } from '../../standalone/usuarios-por-funcion/crear-editar-usuario-funcion/crear-editar-usuario-funcion.component';
// Eventos Técnicos Genéricos
import { EventosTecnicosGenericosComponent } from './eventos-tecnicos-genericos/listado-eventos-tecnicos/eventos-tecnicos/eventos-tecnicos.component';
import { AsignarGenericoComponent } from './eventos-tecnicos-genericos/asignar/asignar.component';
import { VistaTecnicosGenericosComponent } from './eventos-tecnicos-genericos/vista-tecnicos/vista-tecnicos.component';
import { MenuTecnicoGenericoComponent } from './eventos-tecnicos-genericos/listado-eventos-tecnicos/menu-tecnico.component';
import { EventosTecnicosFinalizadosGenericosComponent } from './eventos-tecnicos-genericos/listado-eventos-tecnicos/eventos-tecnicos-finalizados/eventos-tecnicos-finalizados.component';
import { LogsDespachosComponent } from './logs-despachos/logs-despachos-listado/logs-despachos.component';
import { ListadoConfigReenviosComponent } from './config-reenvios/listado-config-reenvios/listado-config-reenvios.component';
import { CrearEditarConfigReenviosComponent } from './config-reenvios/crear-editar-config-reenvio/crear-editar-config-reenvio.component';
import { ListadoLogReenviosComponent } from './log-reenvios/listado-log-reenvios/listado-log-reenvios.component';
import { ListadoInactividadUsuariosComponent } from './inactividad-usuarios/listado-inactividad-usuarios.component';
import { ListadoPeriodoActividadUsuariosComponent } from './periodo-actividad-usuarios/listado-periodo-actividad-usuarios.component';
import { ActividadUsuariosComponent } from './actividad-usuarios/actividad-usuarios.component';
import { ChartComponent } from '../../../auxiliares/chart/chart.component';
import { DispositivosLorawanComponent } from './dispositivos-lorawan/dispositivos-lorawan/dispositivos-lorawan.component';
import { CrearEditarDispositivoLorawanComponent } from './dispositivos-lorawan/crear-editar-dispositivo-lorawan/crear-editar-dispositivo-lorawan.component';
import { DarAltaTrackerComponent } from './trackers/dar-alta-tracker/dar-alta-tracker.component';
import { AgregarPermisoUsuarioComponent } from './usuarios/crear-editar-usuario/agregar-permiso-usuario/agregar-permiso-usuario.component';
import { CrearEditarUsuarioComponent } from './usuarios/crear-editar-usuario/crear-editar-usuario.component';
import { ConfigurarUsuarioComponent } from './usuarios/configurar-usuario/configurar-usuario.component';
import { CredencialesSeguridadDialogComponent } from './usuarios/crear-editar-usuario/credenciales-seguridad-dialog/credenciales-seguridad-dialog.component';
import { ListadoBotonBLEComponent } from './boton-ble/listado-boton-ble/listado-boton-ble.component';
import { ButtonComponent } from '../../../auxiliares/button/button.component';
import { DetallesBotonBLEComponent } from './boton-ble/detalles-boton-ble/detalles-boton-ble.component';
import { DetallesBotonBLEInfoComponent } from './boton-ble/detalles-boton-ble-info/detalles-boton-ble-info.component';
import { AlertasBotonesBLEComponent } from './boton-ble/alerta-boton-ble/alertas-botones-ble.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
// PolygonEditorOlComponent eliminado - no se usaba en templates
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { ListadoReportesGenericosComponent } from '../../standalone/listado-reportes-genericos/listado-reportes-genericos.component';
import { ListadoGatewaysComponent } from './gateways/listado-gateways/listado-gateways.component';
import { CrearEditarGatewayComponent } from './gateways/crear-editar-gateway/crear-editar-gateway.component';
import { DetallesGatewayComponent } from './gateways/detalles/detalles.component';
import { DetallesGatewayInfoComponent } from './gateways/detalles/detalles-info/detalles-info.component';
import { DetallesGatewayMetricasComponent } from './gateways/detalles/detalles-metricas/detalles-metricas.component';
import { GraficosComponent } from '../../../auxiliares/graficos/graficos.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';
import { InfoTableComponent } from '../../../componentes/info-table/info-table.component';
import { StatCardComponent } from '../../../componentes/stat-card/stat-card.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { PageTitleComponent } from '../../../componentes/page-title/page-title.component';
import { ContentCardComponent } from '../../../componentes/content-card/content-card.component';
import { ListadoRolesComponent } from './roles/listado-roles/listado-roles.component';
import { CrearEditarRolsComponent } from './roles/crear-editar-rol/crear-editar-rol.component';
import { PermisosEfectivosDialogComponent } from './usuarios/listado-usuarios/permisos-efectivos-dialog/permisos-efectivos-dialog.component';
import { ListadoAuditoriasComponent } from './auditorias/listado-auditorias/listado-auditorias.component';
import { DetallesAuditoriaDialogComponent } from './auditorias/detalles-auditoria-dialog/detalles-auditoria-dialog.component';
import { ConfigHorariosAtencionComponent } from '../../standalone/config-horarios-atencion/config-horarios-atencion.component';
import { ListadoReportesCombustibleComponent } from '../../../componentes/listado-reportes-combustible/listado-reportes-combustible.component';
import { ListadoCategoriasSelectorComponent } from '../../../componentes/selectores/listado-categoria-selector/listado-categoria-selector.component';
import { CrearEditarListadoCategoriaComponent } from '../../standalone/listado-categorias/crear-editar-listado-categoria/crear-editar-listado-categoria.component';
import { ListadoListadoCategoriasComponent } from '../../standalone/listado-categorias/listado-listado-categorias/listado-listado-categorias.component';
import { ListadoLogsCrudosComponent } from '../logs/listado-logs-crudos/listado-logs-crudos.component';
import { ListadoCategoriasEventosTecnicosComponent } from './categorias-eventos-tecnicos/categorias-eventos-tecnicos.component';
import { ListadoTemasComponent } from './temas/listado-temas/listado-temas.component';
import { CrearEditarTemaComponent } from './temas/crear-editar-tema/crear-editar-tema.component';
import { ExportacionesComponent } from './exportaciones/exportaciones.component';
import { ListadoCategoriasEventosComponent } from '../configuracion/categorias-eventos/listado-categorias-eventos/listado-categorias-eventos.component';
import { CrearEditarCategoriaEventoComponent } from '../configuracion/categorias-eventos/crear-editar-categoria-evento/crear-editar-categoria-evento.component';
import { ListadoTiposEventosComponent } from '../configuracion/tipos-eventos/listado-tipos-eventos.component';
import { ExportacionesAlarmasComponent } from './exportaciones/alarmas/exportaciones-alarmas.component';
import { ExportacionesVehiculosComponent } from './exportaciones/vehiculos/exportaciones-vehiculos.component';
import { ClienteSelectorComponent } from '../../../componentes/selectores/cliente-selector/cliente-selector.component';
import { AlarmaSelectorComponent } from '../../../componentes/selectores/alarma-selector/alarma-selector.component';
import { DatePickerComponent } from '../../../componentes/date-picker/date-picker.component';
import { DecalComponent } from '../../../componentes/decal/decal.component';
import { TemaOverlayComponent } from '../../../componentes/tema-overlay/tema-overlay.component';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';
import { BusquedaZonaService } from '../vehiculos/contenedor-mapa/barra-lateral/busqueda-especifica/busqueda-zona/busqueda-zona.service';
import { BusquedaTelefonoComponent } from './busqueda-telefono/busqueda-telefono.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { SelectorSimDisponibleComponent } from './sims/selector-sim-disponible/selector-sim-disponible.component';
import { DetallePermisoDialogComponent } from './usuarios/listado-usuarios/detalle-permiso-dialog/detalle-permiso-dialog.component';

@NgModule({
  declarations: [
    // Apikeys
    ApikeysComponent,
    CrearEditarApikeyComponent,
    // Clientes
    ListadoClientesGraficoComponent,
    ListadoClientesTablaComponent,
    ListadoClientesComponent,
    CrearEditarClienteComponent,
    ClienteNotasComponent,
    DetallesClienteComponent,
    DetallesClienteInfoComponent,
    CambiarPadreDialogComponent,
    //Dispositivos Lorawan y Gateways
    DispositivosLorawanComponent,
    CrearEditarDispositivoLorawanComponent,
    ListadoBotonBLEComponent,
    DetallesBotonBLEComponent,
    DetallesBotonBLEInfoComponent,
    ListadoGatewaysComponent,
    CrearEditarGatewayComponent,
    DetallesGatewayComponent,
    DetallesGatewayInfoComponent,
    DetallesGatewayMetricasComponent,
    // Trackers
    ListadoTrackersComponent,
    CrearEditarTrackerComponent,
    DetallesTrackerInfoComponent,
    DetallesTrackersComponent,
    DarAltaTrackerComponent,
    // Usuarios
    ListadoUsuariosComponent,
    AgregarPermisoUsuarioComponent,
    CrearEditarUsuarioComponent,
    ConfigurarUsuarioComponent,
    CredencialesSeguridadDialogComponent,
    DetallePermisoDialogComponent,
    TecnicosComponent,
    // Servicios Contratados
    ServiciosComponent,
    CrearEditarServiciosComponent,
    // Eventos Técnicos Genéricos
    EventosTecnicosGenericosComponent,
    EventosTecnicosFinalizadosGenericosComponent,
    VistaTecnicosGenericosComponent,
    MenuTecnicoGenericoComponent,

    //Logs Despachos
    LogsDespachosComponent,
    // Config Reenvios
    ListadoConfigReenviosComponent,
    CrearEditarConfigReenviosComponent,
    ListadoLogReenviosComponent,
    ListadoRolesComponent,
    CrearEditarRolsComponent,
    PermisosEfectivosDialogComponent,
    ListadoAuditoriasComponent,
    DetallesAuditoriaDialogComponent,
    ListadoCategoriasEventosTecnicosComponent,
    ListadoTemasComponent,
    CrearEditarTemaComponent,
    ExportacionesComponent,
    ExportacionesAlarmasComponent,
    ExportacionesVehiculosComponent,
    // Eventos
    ListadoCategoriasEventosComponent,
    CrearEditarCategoriaEventoComponent,
    ListadoTiposEventosComponent,
    // Actividad de usuarios (contenedor con tabs + los dos listados)
    ActividadUsuariosComponent,
    ListadoInactividadUsuariosComponent,
    ListadoPeriodoActividadUsuariosComponent,
  ],
  imports: [
    CommonModule,
    ...PIEZAS_DETALLE,
    AuxiliaresModule,
    SelectorSimDisponibleComponent,
    MapaUnicoPuntoComponent,
    MapaFacilComponent,
    DateRangeSelectorComponent,
    MapDrawMapboxComponent,
    UploadFileComponent,
    AdministracionRoutingModule,
    MatMenu,
    ListadoConfigsEventosComponent,
    ListadoNotasComponent,
    AsignarGenericoComponent,
    ChartComponent,
    ButtonComponent,
    AlertasBotonesBLEComponent,
    CardComponent,
    // UploadFileComponent - ya importado arriba (línea 133)
    // PolygonEditorOlComponent - eliminado (no se usaba),
    JerarquiaClienteComponent,
    ListadoReportesGenericosComponent,
    GraficosComponent,
    EventosGenericosModule,
    MapCardComponent,
    InfoTableComponent,
    StatCardComponent,
    InfoBannerComponent,
    PageTitleComponent,
    ContentCardComponent,
    CrearEditarUsuarioFuncionComponent,
    ConfigHorariosAtencionComponent,
    ListadoReportesCombustibleComponent,
    ListadoCategoriasSelectorComponent,
    CrearEditarListadoCategoriaComponent,
    ListadoListadoCategoriasComponent,
    DatePickerComponent,
    DecalComponent,
    TemaOverlayComponent,
    PasosNavComponent,
    ClienteSelectorComponent,
    AlarmaSelectorComponent,
    MapaFacilComponent,
    BusquedaTelefonoComponent,
    ListadoLogsCrudosComponent,
    ListadoAsignacionsComponent,
  ],
  providers: [BusquedaZonaService],
  exports: [EventosTecnicosGenericosComponent],
})
export class AdministracionModule {}
